import React, { useMemo } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { SivaContractCreateDto } from 'src/api/v2';
import { SivaPhase } from 'src/api/v2';
import { FormStepButtons } from '../FormStepButtons';
import useHeadings from 'src/hooks/use-headings';
import { Fieldset, Radio, useRadioGroup } from '@innovationnorway/cl-react';

type Props = {
  form: UseFormReturn<SivaContractCreateDto>;
  availablePhases: ReadonlyArray<SivaPhase>;
  stepForward: (() => void) | undefined;
  stepBackward: (() => void) | undefined;
  headingLevel?: 'h2' | 'h3';
};

const SelectPhase = ({ form, availablePhases, stepBackward, stepForward, headingLevel = 'h2' }: Props) => {
  const { t: tSiva } = useTranslation('siva');
  const phase = form.watch('sivaPhase');
  const { TopLevel } = useHeadings(headingLevel);
  const phaseOptions = useMemo(
    () =>
      availablePhases.map((key) => ({
        text: tSiva(`phase.${key}`),
        value: key,
        selected: phase === key,
      })),
    [tSiva, phase, availablePhases],
  );

  const { getRadioProps } = useRadioGroup({
    name: 'sivaPhase',
    onChange: (value) => form.setValue('sivaPhase', value as SivaPhase),
    value: form.getValues('sivaPhase'),
  });

  return (
    <>
      <TopLevel>Velg fase</TopLevel>
      <Fieldset>
        {phaseOptions.map((option) => {
          return (
            <Radio
              key={option.value}
              label={option.text}
              name="sivaPhase"
              {...getRadioProps({ value: option.value })}
            />
          );
        })}
      </Fieldset>
      {stepForward && stepBackward && (
        <FormStepButtons stepForward={stepForward} stepBackward={stepBackward} stepForwardDisabled={!phase} />
      )}
    </>
  );
};

export default SelectPhase;
